@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container outrights-container" [ngClass]="optionsClass">
    <div class="option-group-header">
        <span></span>
        <span *ngFor="let header of headerData; trackBy: trackHeader">{{ header }} </span>
    </div>
    <ng-container *ngFor="let group of optionGroups | slice: 0 : visibleOptionsLimit; trackBy: trackGroup">
        <div class="attribute-key">
            <span class="attribute-key-ellipsis">{{ group.options[0].name }}</span>
        </div>

        <ng-container *ngFor="let header of headerData; trackBy: trackHeader">
            @if (getOption(group.options, header); as option) {
                <ms-option
                    [tracking]="trackingSource"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            } @else {
                <div class="option">
                    <div class="option-pick">
                        <div class="option-indicator">
                            <div class="lock">
                                <vn-icon
                                    name="theme-locked-i"
                                    [class]="isEpcotEnabled ? 'option-group-lock-i-icon' : 'option-group-lock-icon'"
                                    [size]="isEpcotEnabled ? '16' : '14'" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </ng-container>
    </ng-container>
</div>

@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }}
        <vn-icon name="theme-right" size="12" class="right-icon" />
    </div>
}
